var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "20px",
        height: "20px",
        viewBox: "0 0 400 400",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("g", { attrs: { id: "SVGRepo_bgCarrier", "stroke-width": "0" } }),
      _vm._v(" "),
      _c("g", {
        attrs: {
          id: "SVGRepo_tracerCarrier",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
        },
      }),
      _vm._v(" "),
      _c("g", { attrs: { id: "SVGRepo_iconCarrier" } }, [
        _c("path", {
          attrs: {
            d: "M153.279 73.6768C167.972 61.7093 193.342 55.7677 212.642 63.4294C274.954 88.1626 240.878 171.392 178.432 163.129C136.34 157.562 138.658 81.0799 171.391 68.0865",
            stroke: "#F09A0FFF",
            "stroke-opacity": "0.9",
            "stroke-width": "16",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M147.066 219.614C146.448 216.777 143.799 205.208 142.889 202.471C139.418 192.049 137.308 181.339 135.456 170.537C134.292 163.73 133.289 156.842 130.509 150.42C130.4 150.168 130.036 149.894 129.775 149.878C129.443 149.86 128.979 149.99 128.772 150.232C128.067 151.057 127.289 151.88 126.829 152.844C118.796 169.608 110.818 186.399 102.803 203.168C101.597 205.692 101.807 208.118 103.048 210.51C104.061 212.452 105.045 214.412 106.217 216.254C111.884 225.173 117.598 234.064 123.322 242.949C124.703 245.089 155.588 281.549 157.169 283.539",
            stroke: "#F09A0FFF",
            "stroke-opacity": "0.9",
            "stroke-width": "16",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M233.783 215.556C239.37 182.716 255.25 149.877 255.25 149.877",
            stroke: "#F09A0FFF",
            "stroke-opacity": "0.9",
            "stroke-width": "16",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M255.25 149.876C257.455 149.811 297.389 194.104 297.389 201.152C297.389 208.201 270.962 254.475 269.805 257.921C268.956 260.456 266.129 270.041 264.17 272.016",
            stroke: "#F09A0FFF",
            "stroke-opacity": "0.9",
            "stroke-width": "16",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            opacity: "0.503384",
            d: "M290.493 333.663C290.133 333.026 289.765 332.388 289.487 331.715C288.785 330.026 288.024 328.349 287.475 326.608C280.845 305.626 271.66 285.703 262.446 265.77C257.999 256.156 254.377 246.163 250.388 236.339C250.112 235.662 249.915 234.957 249.646 234.275C244.246 220.536 247.218 221.82 230.723 222.009C223.025 222.099 215.335 223.069 207.641 223.616C203.613 223.9 199.584 224.211 195.553 224.362C183.071 224.829 170.586 225.215 158.105 225.657C156.64 225.71 155.175 225.884 153.721 226.074",
            stroke: "#F09A0FFF",
            "stroke-opacity": "0.9",
            "stroke-width": "14",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            opacity: "0.503384",
            d: "M270.954 340C259.935 339.406 117.67 338.511 113.27 338.304C110.28 338.16 108.372 335.745 109.024 333.138C112.312 319.978 114.729 306.591 118.998 293.688C121.546 285.998 135.324 240.714 137.069 232.839",
            stroke: "#F09A0FFF",
            "stroke-opacity": "0.9",
            "stroke-width": "14",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            opacity: "0.503384",
            d: "M229.147 274.797C230.293 275.025 231.186 277.385 230.472 278.312C228.163 281.31 225.299 282.402 221.906 281.464C220.156 280.977 218.488 280.163 216.717 279.818C215.738 279.626 214.452 279.834 213.605 280.337C212.059 281.248 210.647 282.422 209.339 283.646C206.211 286.578 202.868 286.313 199.256 284.632C194.607 282.472 190.29 279.973 186.823 276.136C184.748 273.838 181.312 273.765 178.921 275.675C177.249 277.017 175.835 278.656 174.281 280.138C171.959 282.358 169.662 284.601 167.241 286.717C166.841 287.068 165.692 287.085 165.214 286.783",
            stroke: "#F09A0FFF",
            "stroke-opacity": "0.9",
            "stroke-width": "6",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M153.721 254.733L160.617 291.605",
            stroke: "#F09A0FFF",
            "stroke-opacity": "0.9",
            "stroke-width": "16",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }